import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation } from '../../../hooks/use-optimistic-mutation';
import { transformSettingsToApiResponse } from '../transformers';
import type { CustomerGroupBuilderSettingsValidated } from '../types/customer-group.schema';
import type { CustomerGroupApiResponse } from '../types/customer-group-response';
import { QK_GET_CUSTOMER_GROUPS } from './use-customer-groups';
import { useCustomerGroupsApi } from './use-customer-groups-api';

export function useUpdateCustomerGroupSettings() {
  const { customerGroupsApi } = useCustomerGroupsApi();
  const queryClient = useQueryClient();

  return useOptimisticMutation<
    CustomerGroupApiResponse[],
    { slug: string; settings: CustomerGroupBuilderSettingsValidated }
  >({
    queryClient,
    queryKey: QK_GET_CUSTOMER_GROUPS(),
    mutationFn: ({ slug, settings }) => customerGroupsApi.group(slug).settings().update(settings),
    optimisticUpdate: (prev, { slug, settings: newSettings }) => {
      return prev?.map((group) => {
        if (group.slug === slug) {
          return {
            ...group,
            settings: transformSettingsToApiResponse(newSettings),
          };
        }
        return group;
      });
    },
  });
}
